import * as React from 'react';
import { useParams } from 'react-router-dom';

import { DeclarationDetails } from '../containers';

export const DeclarationDetailsPage: React.FC = () => {
  const params = useParams<{ id: string }>();
  const ids = params.id.split('/');

  return (
    <React.Fragment>
      {ids.map((id, index) => (
        <DeclarationDetails key={index} id={id} />
      ))}
    </React.Fragment>
  );
};
